<!--begin header -->
<header class="header">

    <app-header></app-header>

</header>
<!--end header -->

<!--begin section-grey -->
<section class="section-white pb-3 page-content">

    <!--begin services-wrapper -->
    <div class="services-wrapper">

        <!--begin container -->
        <div class="container">

            <div class="row">
                <div class="col-12">
                    <h2 class="text-orange">Licenses</h2>
                </div>
                <div class="col-12 mb-2">
                    <h4 >Singapore</h4>
                    <p>SingX Pte Ltd is a company registered in Singapore (UEN: 201433979Z) and works with licensed
                        remittance operators in each country. In Singapore, SingX works with our group company, SingX
                        Singapore Pte Ltd (UEN: 201533243W) which is regulated as a Major Payment Institution (License
                        number PS20200369) by The Monetary Authority of Singapore (MAS).</p>
                </div>
                <div class="col-12 mb-2">
                    <h4 >Hong Kong</h4>
                    <p>SingX (HK) Co. Ltd was incorporated on 23/12/15, holds a Money Service Operator license issued by
                        Customs and Excise Department (License No 16-09-01908). The principal activity is the provision
                        of cross border remittance services.</p>
                </div>
                <div class="col-12 mb-2">
                    <h4 >Australia</h4>

                    <p>SingX Australia Pty Ltd was incorporated on 07/02/2018 and holds an Australian Financial Services
                        License issued by ASIC. Principal activity is to provide cross border remittance services in
                        Australia.</p>
                </div>
                <div class="col-12 mb-2" style="display: none;">
                    <h4>Canada</h4>
                    <p>SingX Pte Ltd is registered with FINTRAC in Canada as a Foreign Money Service Business (FMSB)
                        with Registration Number M21186348.</p>
                </div>
            </div>

        </div>
        <!--end container -->

    </div>
    <!--end services-wrapper -->

</section>
<!--end section-grey -->

<app-footer></app-footer>